export default "__VITE_ASSET__B1zCKRH1__"